import {
  supportCase,
  supportOperationsState,
  supportOperatorDetail,
  supportQueuePage,
  type SupportCaseActionInput,
  type SupportOperationInput,
  type SupportOperationsQuery,
} from '@dental-staffing-platform/shared';
import { req } from './admin-client.js';
function path(base: string, query: Record<string, string | number | undefined>) {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(query))
    if (value !== undefined && value !== '') params.set(key, String(value));
  return `${base}?${params}`;
}
export const supportOperationsApi = {
  list: async (query: Partial<SupportOperationsQuery>) =>
    supportQueuePage.parse(await req(path('/api/admin/support/cases', query))),
  detail: async (id: string, page = 1, internalPage = 1) =>
    supportOperatorDetail.parse(
      await req(
        path(`/api/admin/support/cases/${encodeURIComponent(id)}`, {
          page,
          internalPage,
          pageSize: 20,
        })
      )
    ),
  operate: async (id: string, input: SupportOperationInput) =>
    supportOperationsState.parse(
      await req(`/api/admin/support/cases/${encodeURIComponent(id)}/operations`, {
        method: 'POST',
        body: JSON.stringify(input),
      })
    ),
  reply: async (id: string, input: SupportCaseActionInput) =>
    supportCase.parse(
      await req(`/api/admin/support/cases/${encodeURIComponent(id)}/events`, {
        method: 'POST',
        body: JSON.stringify(input),
      })
    ),
};
